import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TTextDM from './TTextDM'

export default class TAttendanceWorkShiftBreakItemDM extends Data {
	public static className = 'TAttendanceWorkShiftBreakItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	TimeTo?: number
	TimeFrom?: number
	BeforBreakDuration?: number
	AfterBreakDuration?: number
	Duration?: number
	SequenceNumber?: number
	WorkShiftTypeRID?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TTextDM)
	BreakTypeId?: TTextDM
	@Type(() => TTextDM)
	BreakBeginTypeId?: TTextDM
}